import { useNavigate } from "react-router-dom"
import { setNewConversationSearchSource } from "../../../../store/messagingSlice"
import { addPageAction } from "../../../../utils/newrelic"
import type { InboxViewModel, InboxViewModelProps } from "./InboxViewModelTypes"

export const GeneralViewModel = ({
    dispatch,
}: InboxViewModelProps): InboxViewModel => {
    const navigate = useNavigate()
    const navigateAction = (): void => {
        navigate("/search-users")
        dispatch(setNewConversationSearchSource("icon"))
        addPageAction("DmNewConversationUserSearch", {
            actionType: "init",
            source: "icon",
        })
    }
    const newMessageStarted = (username: string): void => {}

    return {
        newMessageClick: navigateAction,
        newMessageStarted,
    }
}
